import '../assets/Knockout/Knockout.css';
import '../assets/ProximaNova/ProximaNova.css';

// Header and text style size are default for standard desktop

const jimboTypography = {
  fontFamily: 'Proxima Nova',
  fontSize: 15,
  // left out h1, please see PWA style guide. h1 should be left customizable
  h2: {
    fontSize: 40,
    fontWeight: 400,
    fontFamily: 'Knockout69',
  },
  h3: {
    fontSize: 34,
    fontWeight: 400,
    fontFamily: 'Knockout69',
  },
  h4: {
    fontSize: 27,
    fontWeight: 400,
    fontFamily: 'Knockout69',
  },
  h5: {
    fontSize: 25,
    fontStyle: 'Semi Bold',
    fontWeight: 600,
    fontFamily: 'Proxima Nova',
  },
  h6: {
    fontSize: 24,
    fontWeight: 400,
    fontFamily: 'Knockout69',
  },
  subtitle1: {
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'Semi Bold',
  },
  body1: {
    fontWeight: 400,
  },
  button: {
    fontStyle: 'Bold',
    fontWeight: '700',
    fontSize: 14,
  },
};

export default jimboTypography;
